import axios from 'axios';
import Cookies from "js-cookie";
import { WEB_URL } from './config';


const axiosWithoutAuth = axios.create({
  withCredentials: false,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const api = axios.create({
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'X-CSRFToken': Cookies.get('csrftoken'),
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // check with the request event-survey
    if (error.response && error.response.status === 401 && !error?.response?.request.responseURL?.includes('event/login/' || 'event/')) {
      // Redirect to the login page
      Cookies.remove("sessionid");
      Cookies.remove("csrftoken");
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = `${WEB_URL}/login`.replace("//login", "/login");
      return Promise.reject(error); // might actually remove this line, since we are redirecting
    }
    return  Promise.reject(error)
  }
);

export {api,axiosWithoutAuth};


